import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { DxFormModule, DxTextBoxModule, DxSelectBoxModule, DxValidatorModule, DxButtonModule, DxNumberBoxComponent } from 'devextreme-angular';
import { ProjectData } from '../../project-creation-form.component';
import { GpdDateboxComponent } from 'src/app/components/gpd-datebox/gpd-datebox.component';
import { ContactsDropdownBoxComponent } from 'src/app/components/contacts-dropdown-box/contacts-dropdown-box.component';
import { ContactsPopupComponent } from 'src/app/components/contacts-popup/contacts-popup.component';

import { SearchableDropdownDirective } from '../../../../../../directives/searchable-dropdown.directive';
@Component({
    selector: 'app-project-data-step',
    imports: [
        CommonModule,
        DxFormModule,
        DxTextBoxModule,
        DxSelectBoxModule,
        DxValidatorModule,
        GpdDateboxComponent,
        ContactsDropdownBoxComponent,
        ContactsPopupComponent,
        DxButtonModule,
        DxNumberBoxComponent,
        SearchableDropdownDirective
    ],
    templateUrl: './project-data-step.component.html',
    styleUrl: './project-data-step.component.css',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProjectDataStepComponent {
  @Input() projectData: ProjectData;
  @Input() persons: any[] = [];
  @Input() companies: any[] = [];
  @Input() areaTypes: any[] = [];
  @Input() validationGroup: string;

  @Output() onAreaTypeChange = new EventEmitter<number>();
  @Output() onStartDateChange = new EventEmitter<Date>();

  @Output() projectDataChange = new EventEmitter<ProjectData>();

  @ViewChild(ContactsPopupComponent) contactsPopup: ContactsPopupComponent;

  contactPopupTarget: 'epc' | 'partner' | null = null;

  constructor(private cdr: ChangeDetectorRef) {}

  onFieldChanged(field: keyof ProjectData, value: any) {
    const updatedData = { ...this.projectData, [field]: value };
    this.projectDataChange.emit(updatedData);
    this.cdr.detectChanges();
  }

  onPartnerChanged(value: any) {
    if (value) {
      this.projectData.partner = { id: value.data.id, contactType: value.type };
    } else {
      this.projectData.partner = null;
    }
  }

  onEpcChanged(value: any) {
    if (value) {
      this.projectData.epc = { id: value.data.id, contactType: value.type };
    } else {
      this.projectData.epc = null;
    }
  }

  onAreaTypeChanged(value: any) {
    this.onAreaTypeChange.emit(value);
  }

  onStartDateChanged(value: any) {
    this.projectData.startDate = new Date(value);
    console.log(this.projectData.startDate);

    this.onStartDateChange.emit(this.projectData.startDate);
  }

  showContactsPopup(type: 'epc' | 'partner') {
    this.contactPopupTarget = type;
  }

  onNewContactFromDropdown(type: string, target: 'epc' | 'partner'): void {
    this.showContactsPopup(target);
    if (this.contactsPopup) {
      this.contactsPopup.popupSelectedTab = type === 'person' ? 1 : 0;
      this.contactsPopup.editMode = true;
      this.contactsPopup.openedDirectlyInEditMode = true;
    }
  }

  onContactSelected(e) {
    if(e.data){
    this.projectData[this.contactPopupTarget] = { id: e.data.id, contactType: e.type };
    }else{
      this.projectData[this.contactPopupTarget] = null;
    }
    this.contactPopupTarget = null;
  }

  onContactAdded(e) {
    if(e.id){
    this.projectData[this.contactPopupTarget] = { id: e.id, contactType: e.type };
    }else{
      this.projectData[this.contactPopupTarget] = null;
    }
    this.contactPopupTarget = null;
  }
}
